export var InternalLocale;
(function (InternalLocale) {
    InternalLocale["DANISH"] = "da";
    InternalLocale["GERMAN"] = "du";
    InternalLocale["GREEK"] = "el";
    InternalLocale["ENGLISH"] = "en";
    InternalLocale["SPANISH"] = "es";
    InternalLocale["FINNISH"] = "fi";
    InternalLocale["FRENCH"] = "fr";
    InternalLocale["HUNGARIAN"] = "hu";
    InternalLocale["ITALIAN"] = "it";
    InternalLocale["DUTCH"] = "nl";
    InternalLocale["NORWEGIAN"] = "no";
    InternalLocale["POLISH"] = "pl";
    InternalLocale["PORTUGUESE"] = "pt";
    InternalLocale["ROMANIAN"] = "ro";
    InternalLocale["SWEDISH"] = "sv";
    InternalLocale["CHINESE_SIMPLIFIED"] = "zh_CN";
    InternalLocale["CHINESE_TRADITIONAL"] = "zh_TW";
})(InternalLocale || (InternalLocale = {}));
export var RFC4646Locale;
(function (RFC4646Locale) {
    RFC4646Locale["DANISH"] = "da";
    RFC4646Locale["GERMAN"] = "de";
    RFC4646Locale["GREEK"] = "el";
    RFC4646Locale["ENGLISH"] = "en";
    RFC4646Locale["SPANISH"] = "es";
    RFC4646Locale["FINNISH"] = "fi";
    RFC4646Locale["FRENCH"] = "fr";
    RFC4646Locale["HUNGARIAN"] = "hu";
    RFC4646Locale["ITALIAN"] = "it";
    RFC4646Locale["DUTCH"] = "nl";
    RFC4646Locale["NORWEGIAN"] = "no";
    RFC4646Locale["POLISH"] = "pl";
    RFC4646Locale["PORTUGUESE"] = "pt";
    RFC4646Locale["ROMANIAN"] = "ro";
    RFC4646Locale["SWEDISH"] = "sv";
    RFC4646Locale["CHINESE_SIMPLIFIED"] = "zh-Hans";
    RFC4646Locale["CHINESE_TRADITIONAL"] = "zh-Hant";
})(RFC4646Locale || (RFC4646Locale = {}));
export var StripeLocale;
(function (StripeLocale) {
    StripeLocale["DANISH"] = "da";
    StripeLocale["GERMAN"] = "de";
    StripeLocale["GREEK"] = "el";
    StripeLocale["ENGLISH"] = "en";
    StripeLocale["SPANISH"] = "es";
    StripeLocale["FINNISH"] = "fi";
    StripeLocale["FRENCH"] = "fr";
    StripeLocale["HUNGARIAN"] = "hu";
    StripeLocale["ITALIAN"] = "it";
    StripeLocale["DUTCH"] = "nl";
    StripeLocale["NORWEGIAN"] = "no";
    StripeLocale["POLISH"] = "pl";
    StripeLocale["PORTUGUESE"] = "pt";
    StripeLocale["ROMANIAN"] = "ro";
    StripeLocale["SWEDISH"] = "sv";
    StripeLocale["CHINESE_SIMPLIFIED"] = "zh";
    StripeLocale["CHINESE_TRADITIONAL"] = "zh-TW";
})(StripeLocale || (StripeLocale = {}));
export var LocaleLabel;
(function (LocaleLabel) {
    LocaleLabel["DANISH"] = "Dansk";
    LocaleLabel["GERMAN"] = "Deutsch";
    LocaleLabel["GREEK"] = "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC";
    LocaleLabel["ENGLISH"] = "English";
    LocaleLabel["SPANISH"] = "Espa\u00F1ol";
    LocaleLabel["FINNISH"] = "Suomi";
    LocaleLabel["FRENCH"] = "Fran\u00E7ais";
    LocaleLabel["HUNGARIAN"] = "Magyar";
    LocaleLabel["ITALIAN"] = "Italiano";
    LocaleLabel["DUTCH"] = "Nederlands";
    LocaleLabel["NORWEGIAN"] = "Norsk";
    LocaleLabel["POLISH"] = "Polski";
    LocaleLabel["PORTUGUESE"] = "Portugu\u00EAs";
    LocaleLabel["ROMANIAN"] = "Rom\u00E2n\u0103";
    LocaleLabel["SWEDISH"] = "Svenska";
    LocaleLabel["CHINESE_SIMPLIFIED"] = "\u7B80\u4F53\u4E2D\u6587";
    LocaleLabel["CHINESE_TRADITIONAL"] = "\u7E41\u9AD4\u4E2D\u6587";
})(LocaleLabel || (LocaleLabel = {}));
